<template>
  <div class="rf-text-input flex flex-col gap-1">
    <label
      v-if="title || $slots.title"
      class="rf-text-input--title text-body text-grey-1 inline-flex items-center gap-2"
      :for="`input${uid}`"
    >
      <slot name="title">{{ title }}</slot>
    </label>
    <component
      :is="textarea ? 'v-textarea' : 'v-text-field'"
      :id="`input${uid}`"
      v-bind="$attrs"
      :data-cy="$attrs['data-cy']"
      persistentPlaceholder
      persistentCounter
    >
      <template v-for="name in forwardedSlotNames" :key="name" #[name]>
        <slot :name="name" />
      </template>
      <template #label></template>
    </component>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, useSlots } from "vue";

defineOptions({ inheritAttrs: false });
defineProps({
  title: { type: [String, Boolean], default: false },
  textarea: { type: Boolean, default: false },
});
const { uid } = getCurrentInstance();
// "title" is rendered by our own <label> above, not forwarded to the underlying vuetify field.
const slots = useSlots();
const forwardedSlotNames = computed(() => Object.keys(slots).filter(name => name !== "title"));
</script>

<style lang="scss" scoped>
:deep(.v-input__append-inner) {
  margin-top: 0px !important;
  align-self: center !important;
}
:deep(.v-input__details) {
  padding: 0 0.125rem !important;
}
:deep(
  .v-input:not(.v-input--is-focused):not(.v-input--has-state)
    > .v-input__control
    > .v-input__slot
    fieldset
) {
  border-color: rgba(158, 158, 158, 0.47) !important;
}

:deep(.v-messages__message) {
  font-size: 0.9em;
}

.rf-text-input :deep(.v-input .v-field .v-field__outline__notch) {
  display: none;
}
</style>
